export function getLocation() {
  if (typeof window !== 'undefined') {
    return window.location.href;
  }
}
